import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router';

import { scrollToViewById } from 'src/modules/shared/helpers/scroll';
import { useAppDispatch, useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { UrlParams } from 'src/modules/shared/types';
import { useGetTableOfContentQuery } from 'src/store/table-of-contents/tableOfContentsApi';
import { setExpandedIndex } from 'src/store/table-of-contents/tableOfContentsSlice';

export const ChapterReminder: FC = () => {
  let params = useParams<UrlParams>();
  const { bookId } = params;
  const dispatch = useAppDispatch();
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const { chapterToRemind, expandedIndex, clickedOnNavBar } = useAppSelector(
    (state) => state.tableOfContents
  );

  const { data } = useGetTableOfContentQuery(bookId ?? '', {
    skip: !bookId,
  });

  const isSampleTrajectorySelected = data?.chapters.find((item) => item.id === chapterToRemind);

  useEffect(() => {
    if (isScrolled) return;
    if (expandedIndex) return;
    if (clickedOnNavBar) {
      setIsScrolled(true);
      setTimeout(() => {
        scrollToViewById(`chapter-${clickedOnNavBar}`, { block: 'start' });
      }, 1000);
    }
    if (chapterToRemind && !expandedIndex) {
      setIsScrolled(true);

      dispatch(setExpandedIndex(chapterToRemind));

      setTimeout(() => {
        scrollToViewById(`chapter-${chapterToRemind}`, { block: 'start' });
      }, 1000);
    }
  }, [
    chapterToRemind,
    clickedOnNavBar,
    dispatch,
    expandedIndex,
    isSampleTrajectorySelected,
    isScrolled,
  ]);

  return null;
};
